import { PartnerBrand } from '../interfaces/ProductPublicInterface';
import { GET_PARTNER_BRANDS } from '../queries';
import { executeQuery } from '../Utils/helperFunctions';

class OurPartnerBrandsService {
    async getOurPartnerBrands(): Promise<PartnerBrand[]> {
        try {
            const { data } = await executeQuery<{ partnerBrands: PartnerBrand[] }>(GET_PARTNER_BRANDS());
            return data.partnerBrands;
        } catch (error) {
            console.error('Error fetching partner brands:', error);
            throw error;
        }
    }
}

export default OurPartnerBrandsService;
